import { IntegrationCredentialSecret } from '../models/integrationCredential';
import { integrationCredentialSchema } from '../models/integrationCredential.schema';
import { createIntegrationCredentialPayloadSchema } from './create.schema';

export type CreateIntegrationCredentialPayload = {
  name: string;
  type: string;
  secret: IntegrationCredentialSecret;
};

export const create = (payload: CreateIntegrationCredentialPayload) => {
  return {
    endpoint: `/integration_credentials`,
    method: 'POST',
    payload,
    responseSchema: integrationCredentialSchema,
    payloadSchema: createIntegrationCredentialPayloadSchema,
  } as const;
};
